import script from "./alertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./alertModal.vue?vue&type=script&setup=true&lang=js"

import "./alertModal.vue?vue&type=style&index=0&id=b8189dd2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_ada8fe4b8d9a4f6670321c772b1169d5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8189dd2"]])

export default __exports__